import { useQuery } from 'react-query';
import { useSnackbar } from 'notistack';
import history from '@automation/history';
import { getJobDescriptionUrl, getJobsListUrl } from '../../apisPath';
import { fetchApiSimple, getCandoRequestHeaders, getGetConfigSimple, getPostConfigSimple } from '../../utils/fetch';
import JobsTransformation from './transformation';
import JobsQueryKeys from './queryKeys';

const useGetJobList = ({ page = 1, limit = 1000, onSuccess }) => {
  const { enqueueSnackbar } = useSnackbar();

  return useQuery(
    JobsQueryKeys.jobList({ page, limit }),
    () =>
      fetchApiSimple(
        getJobsListUrl(),
        getPostConfigSimple(
          JobsTransformation.queryParams({
            limit,
            page,
          }),
          getCandoRequestHeaders(),
        ),
      ),
    {
      onSuccess,
      select: (data) => JobsTransformation.jobList(data?.jobs),
      onError: (error) => enqueueSnackbar(error.message || error.code || 'خطا', { variant: 'error' }),
    },
  );
};

export const useGetSingleJob = ({ jobId }) => {
  const { enqueueSnackbar } = useSnackbar();
  return useQuery(
    JobsQueryKeys.singleJob({ jobId }),
    () => fetchApiSimple(getJobDescriptionUrl(jobId), getGetConfigSimple(getCandoRequestHeaders())),
    {
      onError: (error) => {
        if (error.status === 404) {
          history.push('/404');
        } else {
          enqueueSnackbar(error.message || error.code || 'خطا', { variant: 'error' });
        }
      },
      select: JobsTransformation.jobDescription,
    },
  );
};

export default useGetJobList;
